import { useTranslation } from 'react-i18next'

import { Alert, Card, CardTitle, SearchInput, Text } from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import ValidationSummary from '@/common/components/ValidationSummary/ValidationSummary'

import ItemsToValidate from './ItemsToValidate/ItemsToValidate'
import UserNotes from './UserNotes/UserNotes'
import * as Styles from './styles'

const PackProductsCard = ({
  lineItems,
  notes,
  onChangeItemStatus,
  onChangeProductCode,
  productCodeError,
  productCode,
  setProductCode,
}) => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Empaquetar productos')}</CardTitle>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Añade uno a uno los códigos de los productos que vas a empaquetar para marcarlos como listos para enviar'
          )}
          :
        </Text>
        <Styles.SearchContainer>
          <SearchInput
            fullWidth
            placeholder={t('SKU, Código de barras (ISBN, UPC, GTIN...)')}
            onSearch={onChangeProductCode}
            searchTimeout={300}
            value={productCode}
            onChangeValue={setProductCode}
          />
          {productCodeError && <Alert type="warning">{t(productCodeError)}</Alert>}
        </Styles.SearchContainer>
        <Divider />
        <ItemsToValidate lineItems={lineItems} onChangeItemStatus={onChangeItemStatus} />
        {notes && <UserNotes notes={notes} />}
        <Divider />
        <ValidationSummary lineItems={lineItems} showTitle={false} />
      </Styles.MainContainer>
    </Card>
  )
}

export default PackProductsCard
